import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_6700_21177)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M8 13.333c2.196 0 4-1.849 4-4.222a6.6 6.6 0 0 0-.332-2.178c-.304-.97-.365-1.096-.686-1.695-.138 1.223-.872 1.733-1.059 1.885 0-.158-.444-1.911-1.118-2.96C8.143 3.133 7.244 2.458 6.716 2c0 .87-.23 2.163-.56 2.822s-.392.683-.803 1.173-.601.642-.946 1.237C4.063 7.827 4 8.619 4 9.202c0 2.373 1.804 4.131 4 4.131Z"
      })
    ], -1)
  ])))
}
export default { render: render }